import { render } from "./SpacesUserTransition.vue?vue&type=template&id=7aa25895&ts=true"
import script from "./SpacesUserTransition.vue?vue&type=script&lang=ts"
export * from "./SpacesUserTransition.vue?vue&type=script&lang=ts"

import "./SpacesUserTransition.vue?vue&type=style&index=0&id=7aa25895&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__